<form *ngIf="form" [formGroup]="form" class="fields-container">
  <div></div>
  <div style="flex-grow: 4">
    <mat-form-field
      *ngIf="!masterOperatorConnectItemSettings"
      [appearance]="fieldAppearance"
      class="field-stretch"
      floatLabel="always"
    >
      <mat-label>{{ T_SCOPE + '.labels.name' | translate }}</mat-label>
      <input
        matInput
        formControlName="name"
        [placeholder]="T_SCOPE + '.placeholders.name' | translate"
        autocomplete="off"
      />
    </mat-form-field>
    <mat-form-field
      *ngIf="!masterOperatorConnectItemSettings"
      [appearance]="fieldAppearance"
      class="field-stretch"
      floatLabel="always"
    >
      <mat-label>{{ T_SCOPE + '.labels.description' | translate }}</mat-label>
      <textarea
        matInput
        formControlName="description"
        row="4"
        [placeholder]="T_SCOPE + '.placeholders.description' | translate"
      ></textarea>
    </mat-form-field>
    <div *ngIf="showSubtitle" class="wtr-subheading custom-subheading">
      {{ T_SCOPE + '.realtime-subheader' | translate }}
    </div>
    <tc-master-operator-connect-form
      formControlName="masterConnectItemsSettings"
      [masterOperatorType]="masterOperatorType"
      [fieldAppearance]="fieldAppearance"
    ></tc-master-operator-connect-form>
  </div>
  <div></div>
</form>
